import {
    Box,
    useTheme,
    useMediaQuery
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useState, useEffect, useRef, Suspense } from 'react';
import Header from './Header';
import CustomScrollBar from '../../../components/CustomScrollBar';
import LoadingScreen from './LoadingScreen';
import Footer from './Footer';
import { isTelegramWebApp } from '../../utils/telegramUtils';

const Layout = ({ children }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(768));
    const location = useLocation();
    const path = location.pathname || '';
    const isEditor = path.includes('/editor/') || path.includes('/services/app/editor/');
    const isSettings = path.includes('/settings/');
    const isShop = path.includes('/shop/');
    const isAnalytics = path.includes('/analytics/');
    const isTg = isTelegramWebApp();

    const headerRef = useRef(null);
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        const updateHeaderHeight = () => {
            if (headerRef.current) {
                setHeaderHeight(headerRef.current.offsetHeight);
            }
        };

        updateHeaderHeight();

        const resizeObserver = new ResizeObserver(updateHeaderHeight);
        if (headerRef.current) {
            resizeObserver.observe(headerRef.current);
        }

        const onResize = () => updateHeaderHeight();
        window.addEventListener('resize', onResize);
        const raf = requestAnimationFrame(updateHeaderHeight);
        const t = setTimeout(updateHeaderHeight, 300);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', onResize);
            cancelAnimationFrame(raf);
            clearTimeout(t);
        };
    }, []);

    useEffect(() => {
        if (headerRef.current) {
            setHeaderHeight(headerRef.current.offsetHeight);
        }
    }, [location.pathname]);

    useEffect(() => {
        let cancelled = false;
        const update = () => {
            if (!cancelled && headerRef.current) {
                setHeaderHeight(headerRef.current.offsetHeight);
            }
        };
        if (document && document.fonts && document.fonts.ready) {
            document.fonts.ready.then(update).catch(() => { });
        }
        return () => { cancelled = true; };
    }, []);

    const content = (
        <Box
            component='main'
            sx={{
                pt: (isMobile || isEditor) ? 0 : `${headerHeight}px`,
                flexGrow: 1,
                px: (isMobile || isTg) ? 1 : 0,
                '--header-height': `${headerHeight}px`,
                transition: 'padding-bottom .2s ease',
                ...((isEditor || isSettings || isShop || isAnalytics) && !isMobile ? { height: '100vh', overflow: 'hidden', boxSizing: 'border-box' } : {})
            }}
        >
            <Suspense fallback={<LoadingScreen text='Загрузка страницы...' />}>
                {children}
            </Suspense>
        </Box>
    );

    return (
        <Box sx={{ maxWidth: isTg ? 900 : 'none', mx: 'auto', width: '100%' }}>
            {!isMobile && !isTg && !isEditor && (<Header ref={headerRef} />)}
            {(isMobile || isTg) ? (
                <Box sx={{ flexGrow: 1, height: 'calc(100dvh - var(--telegram-top-offset, 0px))', pb: 0, overflow: 'hidden' }}>
                    <CustomScrollBar paddingWhenScroll={0} bottomOffset='var(--mobile-bottom-bar-height, 0px)' style={{ maxHeight: '100%', height: '100%' }}>
                        {content}
                    </CustomScrollBar>
                </Box>
            ) : content}
            {(!isMobile && !isEditor && !isSettings && !isShop && !isAnalytics && !isTg) && (<Footer />)}
        </Box>
    );
};

export default Layout;
